export const ERC1155ABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const

export const CUSTOM_COLORS: { [key: string]: string } = {
  USDC: '#2775CA',
  ETH: '#627EEA',
  BTC: '#F7931A',
  USDT: '#26A17B',
  DAI: '#F5AC37',
  OP: '#FF0420',
}

export const CUSTOM_SYMBOL_OVERRIDES: { [key: string]: string } = {
  WETH: 'ETH',
  'USDC.e': 'USDC',
}

export const TOKEN_PRICE_DECIMALS = 18
